export default {
  fr: {
    gem: 'Pépite',
  },
  en: {
    gem: 'Nugget',
  },
  'pt-br': {
    gem: 'Pepita',
  },
  es: {
    gem: 'Pepita',
  },
  de: {
    gem: 'Goldstück',
  },
} as const
